export const compactSpaces = (str: string) => {
  return str ? str.replace(/(\r\n|\n|\r)/gm, '').replace(/\s{2,}/g, ' ') : str;
};
